import { SRMatchStatus } from '@scaleup/models';
import { toTitleCase } from '../../utils';

export const SupplierRequestDealTracker = ({ status }: { status: string }) => {
  return (
    <div className="inline-flex	 rounded-[1rem] h-[40px] gap-[1px]">
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-s-[16px] bg-warning-75 h-[40px] ${status === SRMatchStatus.IN_PROGRESS ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-text-disabled font-black text-[10px]">1</span>
          {status === SRMatchStatus.IN_PROGRESS && (
            <p className="text-white text-sm font-medium text-[10px]">
              Generating Matches
            </p>
          )}
        </div>
        {status !== SRMatchStatus.IN_PROGRESS && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Generating Matches
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-blue-500 h-[40px] ${status === SRMatchStatus.MATCHES_FOUND ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-tertiary-700 font-black text-[12px]">2</span>
          {status === SRMatchStatus.MATCHES_FOUND && (
            <p className="text-white text-sm font-medium text-[10px]">
              Suppliers Presented
            </p>
          )}
        </div>
        {status !== SRMatchStatus.MATCHES_FOUND && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Suppliers Presented
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-primary-500 h-[40px] ${status === SRMatchStatus.MATCHES_FOUND ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-primary-700 text-xs">3</span>
          {status === SRMatchStatus.MATCHES_FOUND && (
            <p className="text-white text-sm font-medium text-[10px]">
              Introductions
            </p>
          )}
        </div>
        {status !== SRMatchStatus.MATCHES_FOUND && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Introductions
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning bg-green-500 h-[40px] ${status === SRMatchStatus.MATCHES_FOUND ? 'w-[168px]' : 'w-[83px] opacity-25'}`}
        >
          <span className="text-green-700 text-xs">4</span>
          {status === SRMatchStatus.MATCHES_FOUND && (
            <p className="text-white text-sm font-medium text-[10px]">
              Negotiations
            </p>
          )}
        </div>
        {status !== SRMatchStatus.MATCHES_FOUND && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Negotiations
          </span>
        )}
      </div>
      <div className="has-tooltip relative">
        <div
          className={`flex justify-center items-center flex-col shadow-warning rounded-e-[16px] bg-secondary-500 h-[40px] ${
            status === SRMatchStatus.MATCHES_FOUND || status == SRMatchStatus.NO_MATCHES_FOUND
              ? 'w-[168px]'
              : 'w-[83px] opacity-25'
          }`}
        >
          <span className="text-secondary-700 text-xs">5</span>
          {(status === SRMatchStatus.MATCHES_FOUND || status === SRMatchStatus.NO_MATCHES_FOUND) && (
            <p className="text-white text-sm font-medium text-[10px]">
              {toTitleCase(status.split('_').join(' '))}
            </p>
          )}
        </div>
        {status !== SRMatchStatus.MATCHES_FOUND && status !== SRMatchStatus.NO_MATCHES_FOUND && (
          <span className="tooltip text-center after:content-[''] after:absolute after:w-0 after:left-1/2 after:h-0 after:border-l-8 after:border-l-transparent after:border-r-8 after:border-r-transparent after:border-t-[16px] after:-bottom-3 after:border-gray-900">
            Deal Status
          </span>
        )}
      </div>
    </div>
  );
};
